import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Car, MapPin, Euro } from 'lucide-react';

const TaxiLiege = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Taxi Liège - Chauffeur Privé Luxe | Service VIP 24/7</title>
        <meta name="description" content="Service de taxi privé de luxe à Liège. Chauffeur professionnel VIP, Mercedes & Lexus. Réservation en ligne instantanée. Prix fixe garanti." />
        <meta name="keywords" content="taxi liège, chauffeur privé liège, taxi luxe liège, vtc liège, transfert liège" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/taxi-liege" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
              Taxi Liège - Chauffeur Privé de Luxe
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Service VIP 24/7 à Liège. Véhicules premium. Réservation instantanée.
            </p>
          </div>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Liège" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Taxi Privé de Luxe à Liège</h2>
          <p className="text-gray-300 mb-4">
            <strong>Taxi Liège</strong> - Service de <strong>chauffeur privé premium</strong> dans la Cité Ardente. 
            Transferts aéroport (Liège Airport, Zaventem, Charleroi), déplacements professionnels, et trajets 
            longue distance. Flotte Mercedes & Lexus, disponible 24/7.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Trajets Populaires depuis Liège</h3>
          <ul className="text-gray-300 space-y-2">
            <li>🚗 Liège → Bruxelles (1h30)</li>
            <li>🚗 Liège → Aéroport Liège (20 min)</li>
            <li>🚗 Liège → Aéroport Zaventem (1h30)</li>
            <li>🚗 Liège → Luxembourg (2h)</li>
            <li>🚗 Liège → Maastricht (30 min)</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TaxiLiege;